import {PageStandard} from "../utils/PageStandard";
import {Button, Card, Chip, CircularProgress, Grid, Stack, Typography} from "@mui/joy";
import { Category, Construction, Group, Label, Map, Translate } from "@mui/icons-material";
import { Link } from "react-router-dom";
import {useEffect, useState} from "react";
import {UtilsModel} from "../utils/Model";
import {getUtils, setAppVersion, setMaintenance} from "../utils/ViewModel";


export function Impostazioni() {

    const [maint, setMaint] = useState<string | null>(null)
    const [ios, setIos] = useState<string | null>(null)
    const [android, setAndroid] = useState<string | null>(null)
    useEffect(() => {
        loadData()
    }, []);

    function loadData() {
        getUtils().then(res => {
            const m = res?.utils.filter(a => a.title === "maintenance")[0]?.value ?? null
            const i = res?.utils.filter(a => a.title === "ios")[0]?.value ?? null
            const a = res?.utils.filter(a => a.title === "android")[0]?.value ?? null
            setMaint(m)
            setIos(i)
            setAndroid(a)
        })
    }

    if (maint === null || ios === null || android === null) return <CircularProgress />
    return (
        <PageStandard title="Impostazioni" sidebarVisible={true}>
            <Grid container spacing={2}>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Card size="lg" sx={{width:"100%", minHeight:"10rem", height: "100%"}} className="hoverScale">
                        <Stack spacing={2} direction="column" justifyContent="center" alignItems="center" sx={{height: "100%"}}>
                            <Chip color={isMaintenance(maint) ? "danger" : "primary"}
                                  size="lg"
                                  sx={{fontWeight: "bold"}}
                            >
                                Manutenzione {isMaintenance(maint) ? "ATTIVATA" : "DISATTIVATA"}
                            </Chip>
                            <Button
                                onClick={() => {
                                    setMaintenance(isMaintenance(maint) ? "false" : "true")
                                        .then(() => loadData())
                                }}
                            >
                                {isMaintenance(maint) ? "Disattiva" : "Attiva"}
                            </Button>
                        </Stack>
                    </Card>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Card size="lg" sx={{width:"100%", minHeight:"10rem", height: "100%"}} className="hoverScale">
                        <Stack spacing={2} direction="column" justifyContent="center" alignItems="center" sx={{height: "100%"}}>
                            <Typography level="h4">Versione minima iOS</Typography>
                            <Chip color="neutral" size="lg" variant="outlined" sx={{fontWeight: "bold"}}>{ios}</Chip>
                            <Button
                                onClick={() => {
                                    let ver = window.prompt("Scrivi la versione minima per iOS", ios)
                                    if(ver !== null) {
                                        setAppVersion("ios", ver)
                                            .then(() => loadData())
                                    }
                                }}
                            >
                                Cambia
                            </Button>
                        </Stack>
                    </Card>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Card size="lg" sx={{width:"100%", minHeight:"10rem", height: "100%"}} className="hoverScale">
                        <Stack spacing={2} direction="column" justifyContent="center" alignItems="center" sx={{height: "100%"}}>
                            <Typography level="h4">Versione minima Android</Typography>
                            <Chip color="neutral" size="lg" variant="outlined" sx={{fontWeight: "bold"}}>{android}</Chip>
                            <Button
                                onClick={() => {
                                    let ver = window.prompt("Scrivi la versione minima per Android", android)
                                    if(ver !== null) {
                                        setAppVersion("android", ver)
                                            .then(() => loadData())
                                    }
                                }}
                            >
                                Cambia
                            </Button>
                        </Stack>
                    </Card>
                </Grid>
            </Grid>
        </PageStandard>
    )

    function isMaintenance(maintenance: String) {
        return maintenance === "true";
    }
}